import axios from 'axios'
import appConfig from '@/appconfig'
import store from '../store'
import endpoint from '@constants/apipath'

export const actions = {
  init({ state, dispatch }) {
    setDefaultAuthHeaders(state)
  },
  fetchOfacPrincipalReport(
    { state },
    {
      userId,
      stateCode,
      customerId,
      customerUserId,
      productId,
      firstName,
      middleName,
      lastName,
      addressLine1,
      addressLine2,
      city,
      stateId,
      zip,
      referenceno,
      reportType,
    } = {}
  ) {

    var reportData = {}
    if (lastName !== '' && lastName !== undefined && lastName !== null) {
      reportData.OrderForUser = customerUserId
      reportData.OrderForCustomer = customerId
      reportData.ProductId = productId
      reportData.Reference = referenceno
      reportData.ReportType = reportType
      reportData.UserId = userId
      reportData.FirstName = firstName
      reportData.MiddleName = middleName
      reportData.LastName = lastName
      reportData.AddressLine1 = addressLine1
      reportData.Street = addressLine1
      reportData.AddressLine2 = addressLine2
      reportData.City = city
      reportData.StateId = stateId
      reportData.StateCode = stateCode
      reportData.Zip = zip
    }
    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.bcrApiPath.ofacprincipalreport}`,
        reportData,

        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
  fetchOfacCommercialReport(
    { state },
    {
      userId,
      stateCode,
      customerId,
      customerUserId,
      productId,
      companyName,
      addressLine1,
      addressLine2,
      city,
      stateId,
      zip,
      referenceno,
      reportType,
    } = {}
  ) {
    var reportData = {}
    if (
      companyName !== '' &&
      companyName !== undefined &&
      companyName !== null
    ) {
      reportData.OrderForUser = customerUserId
      reportData.OrderForCustomer = customerId
      reportData.ProductId = productId
      reportData.Reference = referenceno
      reportData.ReportType = reportType
      reportData.UserId = userId
      reportData.CompanyName = companyName
      reportData.AddressLine1 = addressLine1
      reportData.AddressLine2 = addressLine2
      reportData.City = city
      reportData.StateId = stateId
      reportData.StateCode = stateCode
      reportData.Zip = zip
    }
    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.bcrApiPath.ofaccommericalreport}`,
        reportData,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
}
function setHeaders() {
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${store.state.auth.currentUser.access_token}`,
  }
}

function setDefaultAuthHeaders(state) {
  axios.defaults.headers.get['Pragma'] = 'no-cache'
  axios.defaults.headers.get['Cache-Control'] = 'no-cache, no-store'
  axios.defaults.headers.common.Authorization = state.currentUser
    ? state.currentUser.access_token
    : ''
}
